import { Container } from "@pixi/display";
import { Sprite } from "@pixi/sprite";
import { TriangleView } from "../triangles/TriangleView";
import { GameUIResourcesPackage } from "../../../../preloader/resources/GameUIResourcesPackage";
import { Spine } from "pixi-spine";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { PromiseCompletionSource } from "scene-manager";
import { Timer } from "../../tools/Timer";
export class CellView extends Container {
    private triangles: Array<TriangleView>;
    private _eraseTriangleIndexWithAnimation: number = -1;
    public set eraseTriangleIndexWithAnimation(value: number) {
        this._eraseTriangleIndexWithAnimation = value;
    }

    public constructor(
        private readonly gameResources: GameUIResourcesPackage,
        triangle1?: TriangleView,
        triangle2?: TriangleView
    ) {
        super();
        this.addChild(new Sprite(this.gameResources.assets_game_cell_png));
        this.triangles = new Array<TriangleView>();
        if (triangle1 != null) {
            this.triangles.push(triangle1);
            this.addChild(triangle1);
        }
        if (triangle2 != null) {
            this.triangles.push(triangle2);
            this.addChild(triangle2);
        }
    }

    public async updateCellView(triangles: Array<TriangleView>): Promise<void> {
        let withAnimation = false;
        if (this.triangles.length != triangles.length) {
            withAnimation = true;
        }
        for (let i = 0; i < this.triangles.length; i++) {
            if (this._eraseTriangleIndexWithAnimation != -1 && this._eraseTriangleIndexWithAnimation === i && this.triangles[i] != null) {
                await this.triangles[i].destroyAnimation();
            }
        }
        for (const t of this.triangles) {
            this.removeChild(t);
        }
        this._eraseTriangleIndexWithAnimation = -1;
        this.triangles = triangles;
        for (const t of this.triangles) {
            this.addChild(t);
            if (withAnimation) {
                t.createAnimation();
            }
        }
    }

    public get TriangleViews(): Array<TriangleView> {
        return this.triangles;
    }

    public async destroyTriangle(index: number): Promise<void> {
        const triangle = this.triangles[index];
        const pcs = new PromiseCompletionSource<void>();
        const effect = new Spine((this.gameResources.assets_game_effects_triangles_appearance_destroy_json as any).spineData);
        let animationName = "destroy";
        switch (triangle.RotationStatus) {
            case TriangleRotationStatus.BOTTOM_LEFT: {
                animationName += "_bottom_left";
                break;
            }
            case TriangleRotationStatus.BOTTOM_RIGHT: {
                animationName += "_bottom_right";
                break;
            }
            case TriangleRotationStatus.TOP_LEFT: {
                animationName += "_top_left";
                break;
            }
            case TriangleRotationStatus.TOP_RIGHT: {
                animationName += "_top_right";
                break;
            }
            default: {
                throw new Error("CellView.destroyTriangle: unknown triangle rotation status!");
            }
        }
        effect.state.setAnimation(0, animationName, false).timeScale = 1.3;
        this.addChild(effect);
        effect.state.addListener({
            complete: () => {
                pcs.complete();
            }
        });
        await new Timer(350);
        this.triangles[index].visible = false;
        await pcs.result;
        this.removeChild(effect).destroy({ children: true });
        this.removeChild(triangle).destroy();
        this.triangles[index] = null;
    }

    public get isEmpty(): boolean {
        for (const t of this.triangles) {
            if (t != null) {
                return false;
            }
        }
        return true;
    }
}